module.exports = __webpack_public_path__ + "@/assets/img/salida_intermedia.d5a88263.png";